import React, { useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import Navbar from '../../components/Navbar'
import integration_1 from "../../assets/images/contents/integration-1.png"
import TechnologyTab from '../../components/TechnologyTab'
import IndustriesImageContainer from '../../components/IndustriesImageContainer'
import Footer from '../../components/Footer'
import integration_2 from "../../assets/images/contents/integration-2.gif"
import integration_3 from "../../assets/images/contents/integration-3.png"
import { PrimaryButton } from '../../components/StyledButtons'
import { useSelector } from 'react-redux'
import { selectLanguage } from '../../redux/language/selector'
import filter_color from "../../assets/images/design/colorFilter.svg"
import ModalContactDiscussionForm from '../../components/ModalContactDiscussionForm'

const IntegrationOptions = () => {
  const { t } = useTranslation()

  const language = useSelector(selectLanguage)

  const [modalDiscussionOpen, setModalDiscussionOpen] = useState(false);
    const modalDiscussionRef = useRef(null);
    const handleOverlayClick = (event) => {
        if (modalDiscussionRef.current && !modalDiscussionRef.current.contains(event.target)) {
            setModalDiscussionOpen(false)
        }
    };
    document.onkeydown = function (evt) {
        if (evt.code === 'Escape') {
            setModalDiscussionOpen(false)
        }
    };

  return (
    <div className='integration bg-primary'>
      <div className='color-filter-right' style={{ top: "45%" }}>
                <img src={filter_color} alt="" className='img-responsive' />
            </div>
            <div className='color-filter-left' style={{ top: "60%" }} >
                <img src={filter_color} alt="" className='img-responsive' />
            </div>
      <Navbar />
      <div className='container-fluid integration-header'>
        <div className='container pt-50 pt-md-150'>
          <div className='col-md-6 col-sm-12 px-md-0 pt-lg-100 pt-50'>
            <p className='font-64 font-weight-semi-bold header-title'>{t('integration.header')}</p>
          </div>
          <div className='col-md-6 col-sm-12'>
            <img src={integration_1} alt="overview_1" className='img-responsive' />
          </div>
        </div>
      </div>
      <TechnologyTab integrationOptionsActive={true} />
      <div className='container'>
        <div className='flex justify-center'>
          <div className='technology-chip'>
            <p className='text-center header-title font-40 uppercase'>{t('technology-tab.integration-options')}</p>
          </div>
        </div>
        <div className='col-md-8 col-md-offset-2 pt-30'>
          <p className='text-white text-center'>
            {t('integration.sub-title')}
          </p>
        </div>
      </div>

      <div className='container pt-50'>
        <div className="secure-generation col-sm-12">
          <div className='col-lg-6'>
            <p className='font-32 font-weight-semi-bold'>{t('integration.title-1')}</p>
            <p className='pt-30'>{t('integration.sub-title-1')}</p>
            <p className='pt-20'>{t('integration.content-1')}</p>
            {language === "en"
              ?
              <ul className='list-unstyled pt-10'>
                <li className="checked-line-secondary font-weight-semi-bold">Qrypto Secure QR Code Only</li>
                <li className="checked-line-secondary"><span className='font-weight-semi-bold'>Finished Document PDF</span> (not available for on-premise)</li>
                <li className="checked-line-secondary"><span className='font-weight-semi-bold'>Secure Document Generation and Management</span> (not available for on-premise):</li>
              </ul>
              :
              <ul className='list-unstyled pt-10'>
                <li className="checked-line-secondary font-weight-semi-bold">Chỉ mã QR bảo mật Qrypto</li>
                <li className="checked-line-secondary"><span className='font-weight-semi-bold'>Tài liệu PDF đã hoàn thành</span> (không có sẵn tại chỗ)</li>
                <li className="checked-line-secondary"><span className='font-weight-semi-bold'>Tạo và quản lý tài liệu an toàn</span> (không có sẵn tại chỗ):</li>
              </ul>
            }
          </div>
          <div className='col-lg-6'>
            <div className='flex justify-center'>
              <img src={integration_2} alt="integration_1" className='img-responsive' width="366px" />
            </div>
          </div>
          <div className='col-sm-12 pt-20'>
            {language === "en"
              ?
              <ul className='list-unstyled'>
                <li className="checked-line-secondary"><span className="font-weight-semi-bold">Qrypto Secure QR Code Only:</span> The Qrypto Generator provides the code-graphic image file which can be integrated into the document by your document production system. The Qrypto Generator delivers an option of different sizes of the code to enable more natural incorporation and avoid error-prone image resizing. This is the most common and preferred integration method which provides the highest level of flexibility to customers.</li>
                <li className="checked-line-secondary"><span className="font-weight-semi-bold">Finished Document PDF</span> (not available for on-premise): This requires creating a document template and importing it into the Qrypto Generator. After the template has been imported, the Qrypto Generator will generate both the code, as well as create the PDF of the finished document with the code and the variable data. This is useful if you do not already have such a system.</li>
                <li className="checked-line-secondary"><span className="font-weight-semi-bold">Secure Document Generation and Management</span> (not available for on-premise): Secure Document Generation and Management generates the finished PDF and also provides an end-user user-interface for your users to create secure documents on-demand or on a bulk batch mode basis.</li>
              </ul>
              :
              <ul className='list-unstyled'>
                <li className="checked-line-secondary"><span className="font-weight-semi-bold">Chỉ mã QR bảo mật Qrypto:</span> Trình tạo Qrypto cung cấp tệp hình ảnh đồ họa mã có thể được hệ thống sản xuất tài liệu của bạn tích hợp vào tài liệu. Trình tạo Qrypto cung cấp tùy chọn các kích thước mã khác nhau để cho phép kết hợp tự nhiên hơn và tránh thay đổi kích thước hình ảnh dễ bị lỗi. Đây là phương pháp tích hợp phổ biến và được ưa thích nhất, mang lại mức độ linh hoạt cao nhất cho khách hàng.</li>
                <li className="checked-line-secondary"><span className="font-weight-semi-bold">Tài liệu PDF đã hoàn thành</span> (không có sẵn tại chỗ): Điều này yêu cầu tạo mẫu tài liệu và nhập mẫu đó vào Trình tạo Qrypto. Sau khi mẫu đã được nhập, Trình tạo Qrypto sẽ tạo cả mã cũng như tạo tệp PDF của tài liệu đã hoàn thành với mã và dữ liệu biến đổi. Điều này rất hữu ích nếu bạn chưa có hệ thống như vậy.</li>
                <li className="checked-line-secondary"><span className="font-weight-semi-bold">Tạo và quản lý tài liệu an toàn</span> (không có sẵn tại chỗ): Quản lý và tạo tài liệu an toàn tạo bản PDF hoàn chỉnh và cũng cung cấp giao diện người dùng cuối cho người dùng của bạn để tạo tài liệu an toàn theo yêu cầu hoặc trên cơ sở chế độ hàng loạt.</li>
              </ul>
            }
          </div>
        </div>
      </div>

      <div className='container pt-50'>
        <div className="secure-validation col-sm-12">
          <div className='col-md-12 col-lg-6 pt-lg-70'>
            <img src={integration_3} alt="integration_3" className='img-responsive' />
          </div>
          <div className='col-md-12 col-lg-6 pt-lg-0 pt-50'>
            <p className='font-32 text-white font-weight-semi-bold'>{t('integration.title-2')}</p>
            <p className='text-white pt-30'>{t('integration.sub-title-2')}</p>
            {language === "en"
            ?
            <ul className='list-unstyled pt-20 pb-20'>
              <li className="checked-line"><span className="font-weight-semi-bold">Document Validator App:</span> Qrypto maintains this secure App. It has a mechanism to add customer public key for validation. The validation as well as any decryption for EDC attachments is done on-device with complete privacy.</li>
              <li className="checked-line"><span className="font-weight-semi-bold">Custom App/Existing App:</span> We provide the Qrypto Mobile Validation SDK to embed the validation functionality within a new or existing iOS or Android App.</li>
              <li className="checked-line"><span className="font-weight-semi-bold">Qrypto Validation Server(QVS)</span>: QVS provides an API which accepts file image uploads and returns the Qrypto Secure QR Code details. This is extremely useful for automated processing of inbound documents containing Qrypto secure codes. An example use case would be that of insurance policyholders uploading scanned receipts for the processing of claims.</li>
            </ul>
            :
            <ul className='list-unstyled pt-10 pb-20'>
              <li className="checked-line"><span className="font-weight-semi-bold">Ứng dụng xác thực tài liệu:</span> Qrypto duy trì Ứng dụng an toàn này. Nó có cơ chế thêm khóa công khai của khách hàng để xác thực. Việc xác thực cũng như mọi hoạt động giải mã cho tệp đính kèm EDC đều được thực hiện trên thiết bị với sự riêng tư hoàn toàn.</li>
              <li className="checked-line"><span className="font-weight-semi-bold">Ứng dụng tùy chỉnh/Ứng dụng hiện có:</span> Chúng tôi cung cấp SDK xác thực di động Qrypto để nhúng chức năng xác thực trong Ứng dụng iOS hoặc Android mới hoặc hiện có.</li>
              <li className="checked-line"><span className="font-weight-semi-bold">Máy chủ xác thực Qrypto(QVS)</span>: QVS cung cấp API chấp nhận tải lên hình ảnh tệp và trả về chi tiết Mã QR bảo mật Qrypto. Điều này cực kỳ hữu ích để xử lý tự động các tài liệu gửi đến có chứa mã bảo mật Qrypto. Một trường hợp sử dụng ví dụ là trường hợp chủ hợp đồng bảo hiểm tải lên các biên lai đã quét để xử lý yêu cầu bồi thường.</li>
            </ul>
            }
            <PrimaryButton
            onClick={() => setModalDiscussionOpen(true)}
            >{t('button.schedule-discussion')}</PrimaryButton>
          </div>
        </div>
      </div>

      <div className='container'>
        <IndustriesImageContainer />
      </div>
      <Footer />
      {modalDiscussionOpen && <ModalContactDiscussionForm
                setOpenModal={setModalDiscussionOpen}
                handleOverlayClick={handleOverlayClick}
                modalRef={modalDiscussionRef} />}
    </div>

  )
}

export default IntegrationOptions